<template>
  <div :class="$style.wrapper">
    <header :class="$style.header">
      <div>
        <p :class="$style.headerLabel">Документация</p>
        <h1>Правила платформы SNKRROOM</h1>
      </div>
    </header>

    <section :class="$style.meta">
      <p>
        Правила пользования профессиональной информационной ресейл-платформой
        «SNKRROOM».
      </p>
      <p>
        Актуальная версия Правил находится в разделе «Документация» в личном
        кабинете Участника.
      </p>
    </section>

    <article :class="$style.article">
      <section
        v-for="section in sections"
        :key="section.title"
        :class="$style.section"
      >
        <h2>{{ section.title }}</h2>
        <p v-if="section.subtitle" :class="$style.subtitle">
          {{ section.subtitle }}
        </p>
        <template v-if="section.paragraphs">
          <p v-for="(paragraph, idx) in section.paragraphs" :key="`p-${idx}`">
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list?.length">
          <li v-for="(item, idx) in section.list" :key="`li-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_after">
          <p
            v-for="(paragraph, idx) in section.paragraphs_after"
            :key="`pa-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_after?.length">
          <li v-for="(item, idx) in section.list_after" :key="`lia-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_final">
          <p
            v-for="(paragraph, idx) in section.paragraphs_final"
            :key="`pf-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_final?.length">
          <li v-for="(item, idx) in section.list_final" :key="`lif-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_final2">
          <p
            v-for="(paragraph, idx) in section.paragraphs_final2"
            :key="`pf2-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
        <ul v-if="section.list_final2?.length">
          <li v-for="(item, idx) in section.list_final2" :key="`lif2-${idx}`">
            {{ item }}
          </li>
        </ul>
        <template v-if="section.paragraphs_end">
          <p
            v-for="(paragraph, idx) in section.paragraphs_end"
            :key="`pe-${idx}`"
          >
            {{ paragraph }}
          </p>
        </template>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "DocsRules",
  mounted() {
    // Скрываем MainButton при переходе на эту страницу
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (mb) {
      mb.hide()
    }
  },
  data() {
    return {
      sections: [
        {
          title: "1. Основные положения:",
        list: [
          "Данные Правила пользования профессиональной информационной ресейл-платформой «SNKRROOM» (Далее - Правила) регулируют взаимодействие Участников платформы (далее — Участники) и профессиональной информационной ресейл-платформой «SNKRROOM» (Далее — Платформа);",
          "Нарушение данных Правил может привести к блокировке аккаунта Участника.",
          "Соглашаясь с данными Правилами, Участник полностью и безоговорочно обязуется их соблюдать.",
          "Платформа имеет право изменять данные Правила в одностороннем порядке без личного уведомления Участников. Новая редакция Правил вступает в силу с момента ее публикации на Платформе, если иное не предусмотрено новой редакцией. Продолжение использования Платформы после публикации новой редакции означает согласие Участника с изменениями.",
          "Актуальная версия Правил находится в разделе «Документация» в личном кабинете Участника.",
        ],
        },
        {
          title: "1.1 Термины и определения:",
        paragraphs: [
          "1.2. - Платформа:",
          "Профессиональная информационная ресейл-платформа, оказывающая Участникам услуги информационно-технологического характера, а также услуги по организации расчётов между Участниками за вознаграждение с помощью Telegram — облачного мессенджера для мобильных устройств и компьютеров.",
          "1.2.1. - Участники:",
          "- Реселлер: Участник, приобретающий Товары у Селлеров посредством функционала Платформы;",
          "- Селлер: Участник, размещающий информацию о Товарах на Платформе с целью их продажи Реселлерам;",
          "1.2.2. - Товар:",
          "Предметы (кроссовки), являющиеся объектом сделки между Селлером и Реселлером;",
          "- Заявка: Уведомление Реселлером Селлера о намерении приобрести Товар;",
          "- Заказ: Процесс, следующий после подтверждения Заявки Селлером, который может завершиться Сделкой либо быть прекращён;",
          "- Сделка: Передача Товара Селлером Реселлеру, оформленная с использованием функционала Платформы;",
          "- Удачно завершенная сделка: Сделка, завершённая без нарушений условий передачи, получения, оплаты или возврата Товара;",
          "- Проверка при получении: Визуальный осмотр Товара Реселлером в момент получения. Платформа не проводит Проверку при получении, не выдаёт заключений и не гарантирует результат;",
          "- Внешний сервис проверки: Программное обеспечение или сервис, разработанный и распространяемый третьими лицами (включая SnkrroomExpert), не являющийся частью Платформы. Используется Селлерами по собственному усмотрению. Платформа не является правообладателем, оператором или партнёром таких сервисов;",
          "- Пункт передачи Товара: Помещение, используемое исключительно для физической передачи Товара от Селлера к Реселлеру. Платформа не принимает Товар на хранение, не является хранителем, не становится владельцем Товара и не распоряжается им;",
          "- Подделка (Реплика/Фейк): Товар, произведённый с нарушением исключительных прав правообладателя товарного знака (контрафактный товар);",
          "- Аккаунт: Учётные данные Участника, с помощью которых Участник использует функционал Платформы;",
          "- Блокировка аккаунта: Временное или постоянное ограничение доступа Участника к функционалу Платформы за нарушение правил;",
          "- Служба поддержки: Специализированная служба Платформы, обеспечивающая взаимодействие с Участниками и решение спорных ситуаций или технических проблем, возникших на Платформе, связаться с которой Участник может в личном кабинете;",
          "- Личный кабинет Участника: Раздел приложения, предназначенный для авторизованных Участников. В нём содержится персональная информация Участника и настройки Аккаунта.",
          "- Политика обработки персональных данных: Документ, который описывает правила сбора, использования и защиты персональных данных Участников в соответствии с действующим законодательством Российской Федерации; С Политикой обработки персональных данных Платформы можно ознакомиться в личном кабинете Участника в разделе «Документация».",
        ],
        },
        {
          title: "2. Предмет Правил:",
        paragraphs: [
          "2.1. Платформа посредством специализированной интернет-платформы в Telegram - облачного мессенджера для мобильных устройств и компьютеров, оказывает Участникам услуги информационно-технологического характера. Платформа не является стороной договора купли-продажи, комиссионером, агентом, хранителем, продавцом, владельцем Товара, платёжным агентом или участником расчётов, а лишь обеспечивает взаимодействие между Участниками посредством функционала Платформы.",
          "2.2. В соответствии с Правилами Платформа принимает на себя обязательство за вознаграждение посредством функционала Платформы:",
          "2.2.1. Осуществлять размещение информации о Товарах;",
          "2.2.2. Осуществлять поиск Реселлеров для Селлеров и наоборот;",
          "2.2.3. Предоставлять Участникам техническую возможность проведения расчётов между собой с использованием сервиса «Мультирасчёты» (https://www.tbank.ru/business/online-payments/multi-calculation-service/). Платформа не участвует в расчётах между Участниками и не осуществляет удержание денежных средств Участников;",
          "2.2.4. Предоставлять помещение для физической передачи Товара между Участниками;",
          "2.3. Платформа не осуществляет приёмку, хранение, маркировку Товара и не вводит Товар в оборот от своего имени. Обязанность по соблюдению требований законодательства о маркировке лежит на Селлере.",
        ],
        },
        {
          title: "3. Услуги Платформы за вознаграждение:",
        paragraphs: [
          "3.1. Услугами Платформы за вознаграждение считаются услуги, предусмотренные п. 2.2. настоящих Правил.",
          "3.2. Участники обязуются оплачивать Платформе вознаграждение за услуги информационно-технологического характера согласно п. 9 настоящих Правил. Услуги информационно-технологического характера оказываются Участникам исключительно посредством функционала Платформы.",
          "3.3. Платформа имеет право отказать Участникам в предоставлении услуг без объяснения причин.",
        ],
        },
        {
          title: "4. Регистрация и аккаунт:",
        paragraphs: [
          "4.1. Регистрируясь на Платформе, Участник подтверждает, что достиг возраста 18 (восемнадцати) полных лет на момент регистрации. Регистрация лиц младше 18 лет допускается только с согласия законного представителя.",
          "4.2. В соответствии со ст. 437 ГК РФ, регистрируясь на Платформе, Участник полностью и безоговорочно принимает Правила Платформы.",
          "4.3. Регистрируясь на Платформе, Участник даёт согласие на обработку своих персональных данных, (Платформа входит в Реестр операторов персональных данных под № 77-25-522908. Приказ № 838 от 17.12.2025).",
          "4.4. Платформа проводит модерацию всех аккаунтов, желающих быть зарегистрированными на Платформе, и имеет право отказать в регистрации без объяснения причин.",
          "4.5. Все действия, совершенные с аккаунта Участника, считаются совершёнными самим Участником.",
          "4.6. Запрещено использование аккаунта третьими лицами без согласия владельца аккаунта. Ответственность за сохранность данных своего аккаунта несёт его владелец.",
          "4.7. За использование Платформы в противоправных целях, а также за систематическое нарушение условий сделок, предусмотренных настоящими Правилами, следует блокировка аккаунта Участника. Платформа вправе применить временную блокировку или иные ограничения доступа.",
        ],
        },
        {
          title: "5. Правила Платформы для Селлера:",
        paragraphs: [
          "5.1. Селлер, размещающий информацию о своих Товарах на Платформе, гарантирует, что Товар является его собственностью, не является контрафактным, соответствует описанию и промаркирован в соответствии с требованиями законодательства РФ, если такая обязанность установлена. Размещение подделок на Платформе запрещено. При выявлении подделки аккаунт Селлера блокируется, а Товар возвращается Селлеру.",
          "5.2. Платформа проводит модерацию аккаунтов и каталогов Селлеров. Платформа вправе отказать в регистрации или заблокировать аккаунт без объяснения причин. Допуск Селлера к размещению Товаров не является подтверждением подлинности каждой единицы Товара и не создаёт гарантий Платформы.",
          "5.3. Селлер вправе самостоятельно использовать любые доступные ему инструменты для проверки подлинности Товара перед публикацией, включая, но не ограничиваясь, Внешние сервисы проверки. Использование таких инструментов является личным выбором Селлера и не влияет на его обязательства перед Платформой и Реселлером.",
          "5.4. Селлер несёт полную ответственность за подлинность и качество размещаемого Товара, независимо от использования каких-либо сторонних инструментов проверки.",
          "5.5. Селлер размещает свои Товары по шаблону, предоставленному Платформой. Также возможно добавление Товара вручную. Каталог Селлера проходит модерацию Платформой.",
          "5.6. Для начала работы на Платформе минимальное количество размещаемого Селлером товара должно быть не менее 10 (Десяти) пар.",
          "5.7. Сделка с Реселлером начинается с создания Реселлером заявки на приобретение Товара Селлера.",
          "5.8. Селлер обязан либо принять, либо отклонить заявку Реселлера на приобретение Товара в течение 60 минут с момента уведомления Селлера Платформой о поступлении новой заявки.",
          "5.9. Отклоняя заявку, Селлер указывает предложенную Платформой причину отклонения заявки.",
          "5.10. Подтверждая заявку, Селлер принимает предложение Реселлера о продаже своего Товара по окончательной стоимости (если таковая не будет изменена по согласованию Участников). Окончательной стоимостью товара является та, которую Селлер устанавливает для оплаты Реселлером.",
          "5.11. Селлер обязуется отслеживать ход сделки по статусам:",
        ],
        list: [
          "Новая заявка, подтвердите (Реселлер создал заявку на приобретение Товара. У Селлера есть 60 минут, чтобы подтвердить заявку);",
          "Заказ ожидает оплату (Реселлер должен оплатить заказ в течение 30 минут с момента принятия заявки Селлером);",
          "Заказ оплачен, доставьте Товар в Пункт передачи Товара (Селлер обязан доставить Товар по заказу в Пункт передачи Товара в течение времени, указанного при регистрации на Платформе);",
          "Заказ в Пункте передачи Товара (Товар доставлен Селлером в Пункт передачи Товара);",
          "Заказ готов к выдаче (Товар ожидает получения Реселлером);",
          "Заказ выдан Реселлеру (Реселлер получил Товар);",
          "Сделка завершена (Деньги перечислены Селлеру).",
        ],
        paragraphs_after: [
          "5.12. Для каждого этапа сделки Платформой отводится определённый отрезок времени. Количество оставшегося времени отслеживается с помощью таймера.",
          "5.13. Селлер обязан привязать банковскую карту в своём личном кабинете Платформы для проведения расчётов.",
          "5.14. Денежные средства перечисляются на банковскую карту Селлера с учётом вознаграждения Платформы.",
          "5.15. Услуги пользования Платформой оказываются Селлеру за вознаграждение.",
          "5.16. Размещая Товар на Платформе, Селлер подтверждает, что является владельцем Товара и готов продать его Реселлеру по указанной стоимости.",
          "5.17. Селлер обязан предоставить Товар, оплаченный Реселлером, путём передачи Товара в Пункт передачи Товара в течение времени отправки, выбранного при регистрации на Платформе.",
          "5.18. Селлер передаёт Товар в Пункт передачи Товара. Товар не принимается на баланс Платформы, право собственности на Товар сохраняется за Селлером до момента передачи Товара Реселлеру. УПД, ТОРГ-12 и иные документы о переходе права собственности не оформляются.",
          "5.19. Если Товар Селлера не соответствует заявленному описанию, он возвращается Селлеру. Порядок нахождения такого Товара в Пункте передачи Товара определяется п. 7.7 настоящих Правил.",
          "5.20. В случае возникновения спорных вопросов по сделке Селлер вправе обратиться в службу поддержки Платформы.",
        ],
        },
        {
          title: "6. Правила Платформы для Реселлера:",
        paragraphs: [
          "6.1. Сделка с Селлером начинается с создания Реселлером заявки на приобретение Товара Селлера.",
          "6.2. Создавая заявку, Реселлер делает Селлеру предложение приобрести Товар по указанной Селлером окончательной стоимости (если таковая не будет изменена по согласованию Участников).",
          "6.3. Перед созданием заявки, Реселлер обязан внимательно ознакомиться с информацией, указанной в карточке Товара, который он хочет приобрести.",
          "6.4. Для каждого этапа сделки Платформой отводится определённый отрезок времени. Количество оставшегося времени отслеживается с помощью таймера.",
          "6.5. Реселлер обязан отслеживать ход сделки по статусам:",
        ],
        list: [
          "Заявка создана, ожидайте подтверждения (Селлер должен принять или отклонить заявку);",
          "Заявка подтверждена, оплатите заказ (Реселлеру нужно оплатить свой заказ);",
          "Заказ оплачен, Селлер должен доставить Товар в Пункт передачи Товара;",
          "Заказ в Пункте передачи Товара (Товар доставлен Селлером в Пункт передачи Товара);",
          "Заказ готов к выдаче (Реселлер может забрать Товар по заказу);",
          "Заказ выдан Реселлеру (Реселлер получил свой заказ);",
          "Сделка завершена (Реселлер выкупил Товар по заказу, деньги перечислены Селлеру).",
        ],
        paragraphs_after: [
          "6.6. Получение оплаченного Реселлером Товара осуществляется лично им самим в Пункте передачи Товара. Иные способы получения Товара не предусмотрены.",
          "6.7. Реселлер обязан получить (забрать) или вернуть (если потребуется) оплаченный им Товар по заказу в соответствии с п.7 настоящих Правил.",
          "6.8. Реселлер может завершить сделку досрочно после получения товара, если возврат Товара не требуется. В таком случае сделка будет считаться завершённой, а денежные средства будут перечислены Селлеру.",
          "6.9. Реселлер вправе отказаться от заказа до получения Товара. Отмена заказа возможна до получения Реселлером статуса «Заказ в Пункте передачи Товара», а также «Заказ готов к выдаче». Если Реселлер отменит заказ после получения им данных статусов, сделка прекращается. Вознаграждение Платформы за такую сделку не взимается. Платформа вправе применить к Реселлеру меры, предусмотренные п. 4.7 настоящих Правил, включая временную блокировку аккаунта.",
          "6.10. Если Реселлер нарушает условия возврата Товара, предусмотренные п. 7.4 настоящих Правил, возврат Товара не производится. Последствия такого нарушения определяются п. 7.8 настоящих Правил. Платформа вправе применить к Реселлеру меры, предусмотренные п. 4.7 настоящих Правил, включая временную блокировку аккаунта.",
          "6.11. В случае возникновения спорных вопросов по сделке Реселлер имеет право обратиться в службу поддержки Платформы.",
        ],
        },
        {
          title: "7. Правила получения и возврата Товара Реселлером:",
        paragraphs: [
          "7.1. Получение Товара по заказу Реселлером возможно после того, как статус заказа изменится на «Заказ готов к выдаче» в личном кабинете Реселлера.",
          "7.2. После присвоения заказу статуса «Заказ готов к выдаче» Реселлер обязан в течение 48 часов получить Товар. Если Реселлер не получает Товар в указанный срок, Платформа уведомляет Реселлера о необходимости получить Товар либо сообщить о своём решении.",
          "7.3. Если Реселлер не получает Товар и не сообщает о своём решении в течение 5 (пяти) дней с момента направления уведомления, Товар подлежит возврату Селлеру. Денежные средства, оплаченные Реселлером, возвращаются Реселлеру в полном объёме. Вопросы возмещения расходов Селлера, связанных с неисполнением Реселлером обязанности по принятию Товара, разрешаются между Селлером и Реселлером самостоятельно, без участия Платформы.",
          "7.4. Возврат Товара возможен в следующих случаях, если:",
        ],
        list: [
          "При осмотре Реселлером Товара в момент его получения обнаружено расхождение с заказываемым Реселлером Товаром;",
          "Отсутствуют следы носки, повреждения Товара;",
          "Не нарушена целостность защитной пломбы (шоплока) и сертификат проверки, принадлежащий данному Товару, имеется в наличии;",
          "В наличии имеется весь комплект дополнительных аксессуаров, если таковые имелись у Товара при получении его Реселлером;",
          "Не нарушен срок возврата;",
        ],
        paragraphs_after: [
          "7.5. Возврат Товара возможен только при условии, что Товар, предъявляемый к возврату, полностью идентичен Товару, выданному Реселлеру из Пункта передачи Товара. Идентичность определяется по защитной пломбе (шоплоку), сертификату и иным признакам. При обнаружении признаков подмены Товара возврат не производится, а Товар передаётся Селлеру с уведомлением Реселлера о выявленном расхождении.",
          "7.6. Товар находится в Пункте передачи Товара исключительно для цели его передачи Реселлеру и не является предметом хранения в смысле ст. 886 ГК РФ.",
          "7.7. Товар, возвращённый Селлеру, находится в Пункте передачи Товара до момента его получения Селлером, но не более 7 (семи) календарных дней с момента уведомления. По истечении указанного срока Платформа вправе требовать возмещения расходов на нахождение Товара. Вопросы возмещения разрешаются между Платформой и Селлером в порядке, установленном законодательством РФ. Утилизация Товара не производится.",
          "7.8. В случае нарушения Реселлером условий возврата Товара (п. 7.4) возврат Товара не производится. Товар считается переданным Реселлеру. Сделка считается удачно завершённой. Денежные средства, оплаченные за Товар, перечисляются сервисом «Мультирасчёты» Селлеру в полном объёме в соответствии с поручением Реселлера. Претензии Реселлера по качеству и подлинности Товара к Платформе не принимаются.",
        ],
        },
        {
          title: "8. Проверка при получении:",
        paragraphs: [
          "8.1. Все Товары по заказам перед получением их Реселлером могут быть проверены Реселлером в Пункте передачи Товара. Проверка при получении не является обязательной услугой Платформы.",
          "8.2. Проверка при получении может включать в себя:",
          "а) визуальный осмотр всех элементов Товара;",
          "б) оценку состояния и соответствия заявленному описанию;",
          "в) фотофиксацию.",
          "Методы проверки определяются Реселлером самостоятельно. Платформа не проводит проверку своими силами и не выдаёт заключений о подлинности. Платформа не несет ответственности за скрытые дефекты, не выявленные в ходе визуального осмотра.",
          "8.3. При передаче Товара Реселлеру Платформа может предоставить защитную пломбу (шоплок) с QR-кодом и сертификат проверки по запросу Участника. Указанные элементы прикрепляются к Товару Селлером или Реселлером самостоятельно. Возврат Товара возможен только при наличии неповреждённой защитной пломбы (шоплока) и сертификата проверки. При отсутствии или повреждении пломбы либо сертификата возврат Товара не производится, и применяются последствия, предусмотренные п. 7.8 настоящих Правил.",
          "8.4. Результаты проверки носят справочный характер и не являются гарантией Платформы. Претензии по качеству и подлинности Товара предъявляются Селлеру.",
          "8.5. Отметка о прохождении проверки через Внешние сервисы проверки (включая SnkrroomExpert) носит информационный характер, не является гарантией Платформы и не влияет на её ответственность. Платформа не связана с разработчиком указанных сервисов.",
        ],
        },
        {
          title: "9. Вознаграждение Платформы:",
        paragraphs: [
          "9.1. После удачного завершения сделки Селлер уплачивает Платформе вознаграждение за услуги Платформы в размере 15% от стоимости заказа. Уплата вознаграждения осуществляется через сервис «Мультирасчёты» в порядке, установленном п. 10 настоящих Правил.",
        ],
        },
        {
          title: "10. Порядок расчётов:",
        paragraphs: [
          "10.1. Все расчёты между Участниками осуществляются в российских рублях.",
          "10.2. Платформа не несёт ответственность за корректное предоставление данных банковских карт Участников и не хранит данные банковских карт Участников.",
          "10.3. Все финансовые обязательства по налогообложению Участников, если таковые возникают, берут на себя Участники. Платформа не является налоговым агентом по доходам Участников, полученным в результате совершения сделок на Платформе, и не производит исчисление, удержание и перечисление НДФЛ. Участники самостоятельно несут ответственность за соблюдение налогового законодательства.",
          "10.4. Расчёты между Участниками осуществляются с использованием сервиса «Мультирасчёты» (https://www.tbank.ru/business/online-payments/multi-calculation-service/). Платформа не осуществляет прямых расчётов между Участниками и не является участником расчётов. Расчёты по сделкам совершаются сервисом «Мультирасчёты» на основании поручений Участников в соответствии с правилами указанного сервиса.",
          "10.5. Расчёты между Участниками осуществляются следующим образом:",
        ],
        list: [
          "Реселлер перечисляет денежные средства за Товар с использованием сервиса «Мультирасчёты».",
          "Сервис «Мультирасчёты» учитывает денежные средства Реселлера на номинальном счёте в соответствии с правилами указанного сервиса.",
          "При удачном завершении сделки сервис «Мультирасчёты» перечисляет денежные средства Селлеру в соответствии с поручением Реселлера.",
          "Если заказ отменён Селлером после присвоения заказу статуса «Заказ оплачен, доставьте Товар в Пункт передачи Товара», сервис «Мультирасчёты» возвращает денежные средства Реселлеру в полном объёме в соответствии с правилами указанного сервиса.",
        ],
        paragraphs_after: [
          "10.6. Платформа не осуществляет приёмку, хранение, маркировку Товара и не вводит Товар в оборот от своего имени. Обязанность по соблюдению требований законодательства о маркировке лежит на Селлере.",
        ],
        },
        {
          title: "11. Разрешение споров:",
        paragraphs: [
          "11.1. При возникновении споров, претензий или иных вопросов, Участники имеют право обратиться в службу поддержки Платформы через личный кабинет Участника, а также обратиться по адресу электронной почты info@snkrroom.ru.",
          "11.2. Для разрешения споров по заказам (сделкам) Участнику необходимо предоставить все детали заказа (сделки).",
          "11.3. Все споры между Участниками и/или Платформой, разрешаются путём переговоров. В случае невозможности разрешения споров путём переговоров, Участники и/или Платформа имеют право разрешать споры во внесудебном и/или судебном порядке.",
        ],
        },
        {
          title: "12. Рейтинги участников:",
        paragraphs: [
          "12.1. Каждый Участник имеет свой рейтинг, который складывается из определённых действий Участников. Рейтинг может изменяться как в положительную, так и отрицательную стороны.",
          "12.2. Рейтинг является автоматизированным инструментом и не может гарантировать абсолютную надежность Участника.",
          "12.3. На изменение рейтинга Селлера в положительную сторону влияет:",
        ],
        list: [
          "Количество успешно завершённых сделок;",
          "Количество Товаров, размещённых на Платформе;",
          "Своевременная, либо раньше установленного срока доставка Товара в Пункт передачи Товара;",
          "Дата регистрации Селлера на Платформе.",
          "Количество положительных отзывов;",
        ],
        paragraphs_after: [
          "12.3.1. На изменение рейтинга Селлера в отрицательную сторону влияет:",
        ],
        list_after: [
          "Отмены заявок Реселлеров по разным причинам (кроме причины «Не подходит цена»);",
          "Бездействие Селлера при получении им заявок в течение 60 минут с момента уведомления о них;",
          "Отмены заказов;",
          "Задержки при доставке Товаров по заказам в Пункт передачи Товара;",
          "Случаи, когда Товары Селлера не соответствуют заявленному описанию;",
          "Количество отменённых сделок;",
          "Количество отрицательных отзывов;",
        ],
        paragraphs_final: [
          "12.4. На изменение рейтинга Реселлера в положительную сторону влияет:",
        ],
        list_final: [
          "Количество заказов;",
          "Количество выкупленных позиций Товара;",
          "Количество досрочно завершённых удачных сделок;",
        ],
        paragraphs_final2: [
          "12.4.1. На изменение рейтинга Реселлера в отрицательную сторону влияет:",
        ],
        list_final2: [
          "Отмена заказов после подтверждения Селлером заявок Реселлера;",
          "Количество случаев невозврата Товара в срок;",
          "Отмены заказов по причине их несвоевременной оплаты;",
          "Количество возвратов Товара;",
          "Количество отменённых заказов после получения ими статуса «Заказ готов к выдаче»;",
        ],
        paragraphs_end: [
          "12.5. Платформа оставляет за собой право изменять алгоритм расчета рейтинга.",
        ],
        },
        {
          title: "13. Правила торга:",
        paragraphs: [
          "13.1. На платформе предусмотрена возможность торга за товары Селлеров. Возможность торга даёт Селлеру больше возможностей продать Товар, а Реселлеру купить его по наиболее выгодной для него стоимости.",
          "13.2. Реселлеры могут предлагать свою цену за товар. Селлеры могут включать эту опцию по своему усмотрению. Также по своему усмотрению Селлер вправе отказаться от цены, предложенной Реселлером и продавать Товар по заранее установленной цене.",
          "13.3. Для того, чтобы торговаться за Товар, Реселлеру необходимо предложить свою цену при создании заявки путём выбора опции торга.",
          "13.4. Если Селлера устроит предложенная Реселлером цена, начнётся процесс оформления заказа.",
          "13.5. Селлер вправе отказаться от предложенной Реселлером цены по причине «Не подходит цена».",
          "13.6. Селлер имеет право предложить свою цену в ответ, а Реселлер имеет право принять либо отклонить её. В таком случае Реселлеру нужно будет создать заявку с новой ценой, либо отменить текущую заявку.",
        ],
        },
        {
          title: "14. Отзывы и комментарии:",
        paragraphs: [
          "14.1. После завершения успешной сделки Участник Платформы вправе оставить комментарий о работе Платформы.",
          "14.2. Комментарий должны быть объективными и соответствовать действительности.",
          "14.3. Запрещено использование в комментариях нецензурной (ненормативной) лексики.",
        ],
        },
        {
          title: "15. Ответственность Участников Платформы:",
        paragraphs: [
          "15.1. Участники несут полную самостоятельную ответственность за все действия на Платформе. Любые противоправные действия на Платформе запрещены Участниками в любом виде.",
          "15.2. Запрещен сговор. Любые попытки манипулирования ценами, искусственного завышения или занижения стоимости в сговоре с другими пользователями строго запрещены.",
          "15.3. Запрещен обман. Введение других пользователей в заблуждение, мошеннические схемы. Попытки обойти правила Платформы недопустимы.",
          "15.4. Запрещено размещение на Платформе информации о поддельных (неоригинальных) товарах.",
          "15.5. Все товарные знаки (логотипы, эмблемы), представленные на Платформе, являются зарегистрированными товарными знаками и принадлежат правообладателям. Участникам запрещено использовать зарегистрированные товарные знаки (логотипы, эмблемы) без разрешения правообладателей, либо без иных законных оснований.",
          "15.6. Участники обязаны уважать друг друга. Запрещены оскорбления, угрозы, дискриминационные высказывания в любом виде.",
          "15.7. Во всех своих действия на Платформе Участники несут ответственность в соответствии с действующим Законодательством Российской Федерации.",
        ],
        },
        {
          title: "16. Ограничение ответственности Платформы:",
        paragraphs: [
          "16.1. Платформа не несёт ответственности за:",
        ],
        list: [
          "качество, подлинность и безопасность Товара;",
          "действия или бездействие Участников;",
          "убытки, возникшие в результате сделки;",
          "нарушение Участниками требований законодательства, включая требования о маркировке.",
        ],
        paragraphs_after: [
          "16.2. Платформа не гарантирует, что Товары, размещённые на Платформе, соответствуют требованиям законодательства РФ. Ответственность за соответствие Товара закону лежит на Селлере.",
          "16.3. Максимальная ответственность Платформы ограничена суммой вознаграждения, полученного за конкретную сделку.",
          "16.4. Платформа не несёт ответственности за результаты проверок, проведённых через Внешние сервисы проверки (включая SnkrroomExpert), а также за решения, принятые Участниками на основании таких результатов. Любые отметки о проверке через сторонние сервисы, отображаемые на Платформе, носят исключительно информационный характер и не могут рассматриваться как гарантия Платформы.",
        ],
        },
        {
          title: "17. Форс - мажор",
        paragraphs: [
          "17.1. Участники и/или Платформа не будут нести ответственности за полное или частичное неисполнение своих обязательств, если неисполнение своих обязательств, является следствием наводнения, пожара, землетрясения, пандемии, эпидемии, и других стихийных бедствий или военных действий, возникших после принятия данных Правил.",
          "17.2. Если форс-мажор и его последствия продолжают действовать более 2-х месяцев, то Участники и/или Платформа имеют право отказаться от дальнейшего исполнения обязательств по соблюдению данных Правил. В этом случае Участники и/или Платформа не имеют права на требование возмещения возможных убытков.",
          "17.3. Во всех остальных случаях, не предусмотренных настоящими Правилами, Участники и/или Платформа несут ответственность, предусмотренную действующим законодательством РФ.",
        ],
        },
        {
          title: "18. Контактные данные платформы",
        paragraphs: [
          "18.1. Индивидуальный предприниматель Сукач Олег Ювенальевич. ОГРНИП: 325774600661532. Адрес электронной почты: snkrroomru@gmail.com.",
        ],
        }
      ],


    }
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
}

.header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
}

.headerLabel {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9b9ba1;
  margin: 0 0 0.15rem 0;
}

.header h1 {
  font-size: 1.5rem;
  line-height: 1.2;
  margin: 0;
}

.meta {
  background: #f5f7fa;
  border-radius: 0.75rem;
  padding: 1rem;
  font-size: 0.95rem;
  color: #4b4d52;
  margin-bottom: 1.25rem;
}

.meta p {
  margin: 0 0 0.5rem 0;
}

.meta p:last-child {
  margin-bottom: 0;
}

.article {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.section {
  border: 1px solid #ebeaea;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #fff;
}

.section h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
}

.subtitle {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.section p {
  margin: 0 0 0.5rem 0;
  line-height: 1.45;
  color: #2c2d30;
}

.section ul {
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #2c2d30;
  line-height: 1.4;
}
</style>
